import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_materials_udf_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, ownerId?: number, fullTextSearch?: string, materialIds?: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, Project?: { LookupCode?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_materials_udf_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, ownerId?: number, fullTextSearch?: string, materialIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, Project?: { LookupCode?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_materials_udf_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, ownerId?: number, fullTextSearch?: string, materialIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, Project?: { LookupCode?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_materials_udf_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
